import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import API_URL from "../apiConfig";

import Seo from "../components/Seo";

import "../CSS/index.css";


function NewsDetailPage() {

    const { id } = useParams();

    const [article, setArticle] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");


    // ==================================================
    // BILDPFAD ERZEUGEN
    // ==================================================

    function getNewsImagePath(imageValue) {

        if (!imageValue) {
            return "";
        }

        if (imageValue.startsWith("/")) {
            return imageValue;
        }

        if (
            imageValue.startsWith("http://") ||
            imageValue.startsWith("https://")
        ) {
            return imageValue;
        }

        return `/Fotos/news/${imageValue}`;
    }


    // ==================================================
    // PRÜFEN, OB EIN LINK EXTERN IST
    // ==================================================

    function isExternalLink(linkValue) {

        if (!linkValue) {
            return false;
        }

        return (
            linkValue.startsWith("http://") ||
            linkValue.startsWith("https://") ||
            linkValue.startsWith("www.")
        );
    }


    // ==================================================
    // EXTERNEN LINK AUFBEREITEN
    // ==================================================

    function getExternalLink(linkValue) {

        if (!linkValue) {
            return "";
        }

        if (
            linkValue.startsWith("http://") ||
            linkValue.startsWith("https://")
        ) {
            return linkValue;
        }

        if (linkValue.startsWith("www.")) {

            return `https://${linkValue}`;
        }

        return linkValue;
    }


    // ==================================================
    // EINZELNEN NEWS-BEITRAG LADEN
    // ==================================================

    useEffect(() => {

        fetch(
            `${API_URL}/news.php?id=${id}`
        )

            .then((response) => {

                if (!response.ok) {

                    throw new Error(
                        "News-Beitrag konnte nicht geladen werden."
                    );
                }

                return response.json();
            })

            .then((data) => {

                setArticle(data);
                setIsLoading(false);
            })

            .catch((error) => {

                setError(error.message);
                setIsLoading(false);
            });

    }, [id]);


    // ==================================================
    // LADEANZEIGE
    // ==================================================

    if (isLoading) {

        return (

            <>

                <Seo
                    title="News"
                    description="News von Ivan Jörg."
                    canonical={`https://www.irj.ch/news/${id}`}
                />

                <main className="news-detail-main">

                    <p>
                        Beitrag wird geladen...
                    </p>

                </main>

            </>
        );
    }


    // ==================================================
    // FEHLER
    // ==================================================

    if (error) {

        return (

            <>

                <Seo
                    title="News"
                    description="News von Ivan Jörg."
                    canonical={`https://www.irj.ch/news/${id}`}
                    noIndex={true}
                />

                <main className="news-detail-main">

                    <section className="news-detail-fehler">

                        <p>
                            {error}
                        </p>

                        <Link
                            className="news-detail-zurueck"
                            to="/"
                        >
                            ← Zurück zu den News
                        </Link>

                    </section>

                </main>

            </>
        );
    }


    // ==================================================
    // KEIN BEITRAG
    // ==================================================

    if (!article) {

        return null;
    }


    // ==================================================
    // SEO-BESCHREIBUNG
    // ==================================================

    const seoDescription =
        article.kurztext ||
        article.text ||
        "News von Ivan Jörg.";


    // ==================================================
    // AUSGABE
    // ==================================================

    return (

        <>

            <Seo
                title={article.titel}
                description={seoDescription}
                canonical={`https://www.irj.ch/news/${article.id}`}
            />


            <div className="intro">

                <p>
                    News von Ivan Jörg
                </p>

            </div>


            <main className="news-detail-main">

                <article className="news-detail-artikel">

                    {
                        article.bild && (

                            <div className="news-detail-bild">

                                <img
                                    src={
                                        getNewsImagePath(
                                            article.bild
                                        )
                                    }
                                    alt={
                                        article.titel
                                    }
                                />

                            </div>

                        )
                    }


                    <div className="news-detail-inhalt">

                        <span className="news-detail-datum">
                            {article.datum}
                        </span>


                        <h1>
                            {article.titel}
                        </h1>


                        <p className="news-detail-text">
                            {article.text}
                        </p>


                        {
                            article.link_text &&
                            article.link_ziel && (

                                isExternalLink(
                                    article.link_ziel
                                )

                                    ? (

                                        <a
                                            className="news-link"
                                            href={
                                                getExternalLink(
                                                    article.link_ziel
                                                )
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {article.link_text}
                                        </a>

                                    )

                                    : (

                                        <Link
                                            className="news-link"
                                            to={
                                                article.link_ziel
                                            }
                                        >
                                            {article.link_text}
                                        </Link>

                                    )

                            )
                        }


                        <br />
                        <br />


                        <Link
                            className="news-detail-zurueck"
                            to="/"
                        >
                            ← Zurück zu den News
                        </Link>

                    </div>

                </article>

            </main>

        </>
    );
}


export default NewsDetailPage;